import React from "react";
import { Button, Modal } from "antd";
import conf from "../config";

import { hasFeature } from "../utils/componentVisibility";
const features = {
  showHelpInfo: hasFeature("showHelpInfo"),
  showHelpEmail: hasFeature("showHelpEmail"),
};
const helpEmail = localStorage.getItem("helpEmail") || conf.helpEmail;
const helpPhone = localStorage.getItem("helpPhone") || conf.helpPhone;
const HelpModal = ({ show, closeModal }) => {
  const shareToWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=${helpPhone}&text&type=phone_number&app_absent=0`
    );
  };

  const sendEmail = () => {
    window.open("https://www.google.com/intl/en/gmail/about/");
  };

  return (
    <>
      <Modal
        title="Support"
        open={show}
        onCancel={() => closeModal()}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {features.showHelpEmail &&
            <Button
              onClick={() => sendEmail()}
              icon={
                <i
                  class="bi bi-envelope"
                  style={{ fontSize: "18px", color: "red" }}
                ></i>
              }
            >

              {helpEmail}
            </Button>

          }
          {features.showHelpInfo &&
            <Button
              onClick={() => shareToWhatsApp()}
              icon={
                <i
                  class="bi bi-whatsapp"
                  style={{ fontSize: "18px", color: "green" }}
                ></i>
              }
            >
              &nbsp;      {"+966115003419"}
            </Button>}

          <Button
            icon={
              <i
                class="bi bi-telephone"
                style={{ fontSize: "18px", color: "teal" }}
              ></i>
            }
          >
            {helpPhone}
          </Button>
        </div>
        <br />
        <p>
          If you need further assistance, please contact the provided support
          numbers.
        </p>
      </Modal>
    </>
  );
};

export default HelpModal;
